import {
  GET_CASHFREE_FAILED,
  GET_CASHFREE_REQUESTED,
  GET_CASHFREE_SUCCESS,
  GET_CASHFREE_VERIFY_FAILED,
  GET_CASHFREE_VERIFY_REQUESTED,
  GET_CASHFREE_VERIFY_SUCCESS
} from "resources/actionTypes";

const intialState = {
  userCashfree: [],
  loading: false,
  error: null,
};
const intialStateResponse = {
  userCashFreeResponse: [],
  loading: false,
  error: null,
}
export function userCashFree(state = intialState, action) {
  switch (action.type) {
    case GET_CASHFREE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CASHFREE_SUCCESS:
      return {
        ...state,
        loading: false,
        userCashfree: action.userCashFree,
      };
    case GET_CASHFREE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
export function userCashFreeResponse(state = intialStateResponse, action) {
  switch (action.type) {
    case GET_CASHFREE_VERIFY_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CASHFREE_VERIFY_SUCCESS:
      return {
        ...state,
        loading: false,
        userCashFreeResponse: action.userCashfreeResponse,
      };
    case GET_CASHFREE_VERIFY_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
